import { useEffect, useRef, useState } from "react"

export const DynamicContainer = ({
	children,
	className,
	style,
	initialWidth,
}) => {
	const content = useRef(null)
	const [rect, setRect] = useState({ width: 0, height: 0 })

	useEffect(() => {
		setInterval(() => {
			if (content?.current?.getBoundingClientRect) {
				setRect(content.current.getBoundingClientRect())
			}
		}, 100)
	}, [children])

	return (
		<div
			className={className}
			style={{
				transition: "0.3s",
				height: `${rect.height}px`,
				overflow: "hidden",
				...style,
			}}
		>
			<div
				ref={content}
				style={{
					height: "fit-content",
				}}
			>
				{children}
			</div>
		</div>
	)
}
